import joi from 'joi'
import accountReference from './accountReference'
import authenticationContext from './authenticationContext'

const schema = joi.object({
  accountReference: accountReference.required(),
  authenticationContext: authenticationContext.required(),
  srcCorrelationId: joi.string(),
  srciTransactionId: joi.string(),
  serviceId: joi.string().required(),
  srcClientId: joi.string().guid().required(),
  traceId: joi.string()
})

export default schema
